
import ExpectFromUs from '@/components/ExpectFromUs.vue';
import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: {
    ExpectFromUs,
  },
})
export default class WorkWithUs extends Vue {
}
